export default __webpack_public_path__ + "static/media/casaduana_objetivo03.2244fa8d.jpg";